import store from 'redux/store';
import { getAuthCookieInfo } from 'utils/functions/authentication';
import { fetchLoginInfo } from 'modules/accountManagement/actions';
import { fetchConfigurations } from 'modules/common/actions';

const initApp = () => {
  const { userKey } = getAuthCookieInfo();

  const body = {
    userKey,
  };
  store.dispatch(fetchLoginInfo(body));
  store.dispatch(fetchConfigurations());
};

export default initApp;
